import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=3ed1ee50"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports